import React from 'react';
import './aboutus.css';

import whoweare_img from '../../assets/whoweare_img.png';






function AboutUs() {
  return (
    <div className="about-container">
      <section className="about-banner">
        <h1>Chavo Tours</h1>
        <p>Your trusted partner for seamless and comfortable vehicle bookings.</p>
      </section>


                <div className="container mb-5">
                  <div className="row align-items-center">
                  <div className="col-md-6 custom-para">
                    <h2>Who We Are</h2>
                    <p>
                      At Chavo Tours, we are proud to be your trusted partner in providing premium taxi services. With a commitment to excellence, we ensure every journey is comfortable, reliable, and tailored to meet your needs.
                    </p>
                    
                    <p>
                      Chavo Tours stands out as a leader in Sri Lanka's transportation industry. Our network spans a wide range of locations, offering easy accessibility for both short-distance and long-distance travel. Whether you're heading to the airport, exploring the city, or embarking on a road trip, we've got you covered.
                    </p>
                    
                    <p>
                      Our mission is to deliver world-class transportation services that prioritize safety, punctuality, and customer satisfaction. Every ride with Chavo Tours is backed by professionally trained drivers, well-maintained vehicles, and a seamless booking experience designed to make travel stress-free.
                    </p>
                    
                    <p>
                      We take pride in offering diverse travel options, from solo rides to group transport, ensuring that we cater to all customer requirements. With a focus on sustainable practices and continuous innovation, Chavo Tours is more than just a taxi service—it's a commitment to exceptional journeys.
                    </p>
                    
                    <p>
                      Experience the difference with Chavo Tours, where every trip is more than just a ride—it's a journey crafted with care and precision. Choose Chavo Tours for transportation that exceeds expectations.
                    </p>
                  </div>

                    <div className="col-md-6">
                    <img
                    src={whoweare_img}
                    alt="Who We Are"
                    className="img-fluid rounded custom-img"
                    />
                    </div>
                  </div>
                </div>



      <div className="panels">
        <section className="about-content panel mission-panel">
          <h2>Our Mission</h2>
          <p>
            At Chavo Tours, our mission is to redefine travel convenience by providing reliable, safe,
            and top-tier vehicle booking services. We prioritize customer satisfaction, ensuring a
            smooth and hassle-free experience for every journey.
          </p>
        </section>

        <section className="about-content panel vision-panel">
          <h2>Our Vision</h2>
          <p>
            To be the most trusted and innovative vehicle booking service, connecting people with
            destinations effortlessly. Our goal is to set new industry standards in reliability and
            excellence.
          </p>
        </section>

        <section className="about-content panel values-panel">
          <h2>Our Core Values</h2>
          <ul>
            <li>Commitment to Customer Satisfaction</li>
            <li>Unwavering Reliability and Safety</li>
            <li>Innovation in Travel Solutions</li>
            <li>Eco-Friendly and Sustainable Practices</li>
          </ul>
        </section>
      </div>

      <section className="team panel">
        <h2>Meet Our Team</h2>
        <p>
          Our team consists of experienced professionals dedicated to providing exceptional service.
          From customer support to operations, every team member ensures that your travel experience
          is smooth and enjoyable.
        </p>
        <div className="team-images">
          <div className="team-member">
            <img src="user.jpg" alt="Pathum Vidusanka" />
            <h3>Pathum Vidusanka</h3>
            <p>Lead Driver</p>
          </div>
          <div className="team-member">
            <img src="user.jpg" alt="Dineth Prabhashwara" />
            <h3>Dineth Prabhashwara</h3>
            <p>Operations Manager</p>
          </div>
          <div className="team-member">
            <img src="user.jpg" alt="M. Senon" />
            <h3>M. Senon</h3>
            <p>Customer Support</p>
          </div>
          <div className="team-member">
            <img src="user.jpg" alt="New Team Member" />
            <h3>Amaya Fernando</h3>
            <p>Marketing Coordinator</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;
